import { Routes } from '@angular/router';
import { UserAndSettingsResolver } from '@core/resolvers/user-and-settings.resolver';
import { pagesPrefixRedirectMatch } from './pages/legacy-redirects';

export const appRoutes: Routes = [
	{
		path: 'auth',
		loadChildren: () => import('./auth/auth.routes').then(m => m.authRoutes)
	},
	{
		// Every page used to live under /pages, see legacy-redirects.ts.
		path: 'pages',
		canMatch: [pagesPrefixRedirectMatch],
		children: []
	},
	{
		// Access is enforced by the single canActivateChild in pages.routes.ts, which
		// covers every page below it. Guards run before resolvers, so the resolver
		// here still never fires for someone who is not allowed in. Unknown URLs end
		// up at the not-found page in there too.
		path: '',
		resolve: { userData: UserAndSettingsResolver },
		loadChildren: () => import('./pages/pages.routes').then(m => m.pageRoutes)
	}
];
